// extracted by mini-css-extract-plugin
export var deleteModal = "_q9-0";